export const BP_REFRESH_TOKEN_COOKIE = "bp_refresh_token";
export const BP_TOKEN_COOKIE = "bp_token";

// CSRF token is used to protect against cross-site request forgery attacks
export const CSRF_TOKEN_COOKIE = "csrf_token";

// Experience ID is a persistent uuid stored in the user's cookies
// It enables us to serve a consistent feature flag experience from
// the user's first interaction with the site (as guest) through a
// login transition (and optionally back to guest again)
export const EXPERIENCE_ID_COOKIE = "experience_id";

// Long-term storage key for fingerprint data
export const LONG_TERM_STORAGE_KEY = "fingerprint-lt";

// Test Identity is a persistent value stored in the user's cookies
// It enables us to serve a feature flag experience for testing
export const TEST_IDENTITY_ID_COOKIE = "test_identity";

// Used to store the user segment which can be one of:
//  "lapsedmember" | "member" | "non-member"
export const USER_SEGMENT_COOKIE = "user_segment";
